import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginuiComponent } from './login-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LoginuiComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule
  ],
  exports:[LoginuiComponent]
})
export class LoginuiModule { }
